import { analyzeSentiment } from "@src/sentiment";
import {
  getAnimationType,
  type AnimationType,
} from "@src/utils/animationUtils";
import { useCallback, useState } from "react";
import AnimationDisplay from "./AnimationDisplay";
import ChatBubble from "./ChatBubble";
import MessageInput from "./MessageInput";

function getResponse(userMessage: string): string {
  const lowerCaseInput = userMessage.toLowerCase();
  if (lowerCaseInput.includes("hello")) {
    return "Hi there!";
  } else if (lowerCaseInput.includes("goodbye")) {
    return "See you later!";
  } else {
    return "I am a chatbot.";
  }
}

function Chatbot() {
  const [message, setMessage] = useState(
    "🤖 Hello! I am a sentiment-aware chatbot. How can I help you?",
  );
  const [animationType, setAnimationType] = useState<AnimationType | null>(
    null,
  );

  const handleSendMessage = useCallback((userMessage: string) => {
    if (!userMessage.trim()) {
      return;
    }

    const sentimentResult = analyzeSentiment(userMessage);
    const animation = getAnimationType(sentimentResult.dominantEmotion);
    const response = getResponse(userMessage);

    setAnimationType(animation);
    setMessage(response);
  }, []);

  return (
    <main
      className="animate-slideUp flex w-full max-w-[480px] flex-col gap-6 rounded-2xl border border-cyan-100 bg-white p-8 shadow-[0_10px_40px_rgba(8,145,178,0.15)] dark:border-slate-700 dark:bg-slate-950 dark:shadow-[0_10px_40px_rgba(0,0,0,0.5)]"
      role="main"
      aria-label="Chatbot interface"
    >
      <ChatBubble message={message} />
      <AnimationDisplay animationType={animationType} />
      <MessageInput onSendMessage={handleSendMessage} />
    </main>
  );
}

export default Chatbot;
